import { UseMutationOptions } from '@tanstack/react-query';

import { SegmentDefinition } from 'domains/segments/types';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

export type UpdateCampaignExitCriteriaInput = {
    exitSegmentDefinition: SegmentDefinition | null;
};

export type UpdateCampaignExitCriteriaResponse = { id: string };

/**
 * Updates the campaign-level exit criteria for a campaign. Works even on a live campaign.
 * - PUT /campaigns/:campaignId/exit-criteria with body { exitSegmentDefinition: SegmentDefinition | null }
 * @param campaignId the UUID of the campaign to update
 * @param mutateOptions react-query useMutation options
 * @returns the react-query useMutation result
 * See https://react-query-v3.tanstack.com/reference/useMutation for options and return value
 */
const useUpdateCampaignExitCriteria = (
    campaignId: string,
    mutateOptions?: UseMutationOptions<UpdateCampaignExitCriteriaResponse, Error, UpdateCampaignExitCriteriaInput>
) => {
    const path = `${CuredApiPaths.CAMPAIGNS}/${campaignId}/exit-criteria`;

    return useMutation<UpdateCampaignExitCriteriaInput, UpdateCampaignExitCriteriaResponse>(
        MutationKeys.UPDATE_CAMPAIGN_EXIT_CRITERIA(campaignId),
        path,
        mutateOptions,
        ApiMethods.PUT
    );
};

export default useUpdateCampaignExitCriteria;
